/********************************************************************
 * Copyright (c) Certus Software, 2021.                             *
 *                                                                  *
 * This unpublished material is proprietary to Certus Software.     *
 * All rights reserved. The methods and techniques described        *
 * herein are considered confidential and/or trade secrets.         *
 * Reproduction or distribution, in whole or in part, is forbidden  *
 * except by express written permission of Certus Software.         *
 ********************************************************************/

import {Component} from '@angular/core';
import {SpinnerServiceService} from '../../@shared/_services/spinner-service.service';

@Component({
  selector: 'app-spinner-component',
  'template': '<div *ngIf="active" class="spinner-loading">' +
    '<div class="lds-grid"><div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div>' +
    '</div>'
})
export class SpinnerComponent {
  public active: boolean;

  public constructor(spinner: SpinnerServiceService) {
    spinner.status.subscribe((status: boolean) => {
      this.active = status;
    });
  }
}
